import { render, staticRenderFns } from "./answerFeedback.vue?vue&type=template&id=8e27eff6&scoped=true"
import script from "./answerFeedback.vue?vue&type=script&lang=js"
export * from "./answerFeedback.vue?vue&type=script&lang=js"
import style0 from "./answerFeedback.vue?vue&type=style&index=0&id=8e27eff6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e27eff6",
  null
  
)

export default component.exports